module.exports = __webpack_public_path__ + "img/l4.a265c5ea.png";